import countdownConfig from './countdown'

const starts = '2025-09-24T08:00:00-07:00'
const registrationConfig = {
  starts,
  ends: countdownConfig.starts,
  pricing: {
    earlyBird: {
      starts,
      ends: '2026-01-18T23:59:59-07:00',
      threeDay: 99,
      oneDay: 69,
    },
    standard: {
      starts: '2026-01-19T00:00:01-07:00',
      ends: '2026-03-07T18:00:00-07:00',
      threeDay: 129,
      oneDay: 79,
    },
    door: {
      starts: '',
      ends: '',
      threeDay: 149,
      oneDay: 99,
    },
  },
  eventCodes: {
    integration: 'K7NBVLHFX85',
    beta: 'K7NBVLHFX85',
    www: 'W2NW8Y4HYQ4',
  },
  promoVideos: {
    de: 'XdIxhuY_zlg',
    en: 'zzGzbHoIFhk',
    es: 'tCxu5nMw1sU',
    fr: 'p_hqf6USeWk',
    it: '7mA31fxTmAg',
    ja: 'nGqPJGTATV4',
    ko: 'UT4m5iFnBgE',
    mn: 'zzGzbHoIFhk', // english for now since there is no mn translation
    pt: 'IICNZSgN528',
    ru: 'csiutIuVFz8',
    zh: 'T03P9Z3aJyw',
    'zh-hans': 'ZGrheJKq3w8',
  },
}

export default registrationConfig
